import { imgAuthSlide } from "@/shared/assets/img";
import { TriangleArrowDownIcon } from "@/shared/icons";

function AuthSlider() {
  return (
    <div className="grow w-72.5 rounded-2xl overflow-hidden relative">
      <div
        className="absolute inset-0 bg-cover"
        style={{ backgroundImage: `url(${imgAuthSlide})` }}
      />
      <div className="absolute bottom-2.5 inset-x-2.5 h-13 backdrop-blur rounded-2xl overflow-clip bg-gradient-red bg-gradient-alpha-40  flex justify-end gap-1.25 p-1.25">
        <button
          type="button"
          disabled
          className="aspect-square btn variant-solid-gradient disabled:opacity-50 p-0 h-full"
        >
          <TriangleArrowDownIcon size={10} className="-rotate-90" />
        </button>
        <button
          type="button"
          className="aspect-square btn variant-solid-gradient disabled:opacity-50 p-0 h-full"
        >
          <TriangleArrowDownIcon size={10} className="rotate-90" />
        </button>
      </div>
    </div>
  );
}

export default AuthSlider;
